
import EDChip from '../../BaseComponents/Chip/EDChip';
import EDIcon from '../../BaseComponents/Icon/EDIcon';
import { IconType } from '../../BaseComponents/Icon/Utils/IconDefinitions';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import {
  useIsExtraSmallScreen,
  useIsSmallScreen,
} from '../../Hooks/useFullscreenView';
import EDBox from '../../BaseComponents/EDBox/EDBox';

interface IProps<T> {
  label?: string;
  value: T;
  setValue: (value: T) => void;
  choices: Array<IChipChoice<T>>;
  className?: string;
  style?: React.CSSProperties;
}

export interface IChipChoice<T> {
  label: string;
  value: T;
  icon: IconType;
}

/**
 * Radiobuttons implementation med Chip komponenter.
 * Endast ett av valen kan väljas i taget.
 */

export const ChipRadioButtons: <T>(
  props: IProps<T>
) => React.ReactElement<IProps<T>> = props => {
  const isExtraSmall = useIsExtraSmallScreen();
  const isSmall = useIsSmallScreen();
  return (
    <div className={props.className} style={props.style}>
      {props.label && <EDTypography bold>{props.label}</EDTypography>}
      <EDBox sx={{ display: 'flex', padding: '16px 0px' }}>
        {props.choices.map(t => {
          const selected = t.value === props.value;
          return (
            <EDChip
              key={t.value as unknown as React.Key}
              onClick={() => props.setValue(t.value)}
              label={<EDTypography color="inherit">{t.label}</EDTypography>}
              icon={
                !isExtraSmall ? (
                  <EDIcon
                    color="secondary"
                    iconType={t.icon}
                    chipRadioButtonIcon
                    selectedIcon={selected}
                  />
                ) : undefined
              }
              fullWidth
              margin={isSmall ? '0px 2px' : '0px 4px'}
              chipRadioButton
              chipRadioButtonSelectedChip={selected}
            />
          );
        })}
      </EDBox>
    </div>
  );
};

export default ChipRadioButtons;
